export enum SocialIframeSource {
  Instagram = 'instagram',
  Tiktok = 'tiktok',
  Facebook = 'facebook',
}

export const iframeSizeDesktop = {
  [SocialIframeSource.Instagram]: {
    width: 324,
    height: 406,
  },
  [SocialIframeSource.Facebook]: {
    width: 340,
    height: 132,
  },
};

export const iframeSizeMobile = {
  [SocialIframeSource.Instagram]: {
    width: 302,
    height: 391,
  },
  [SocialIframeSource.Facebook]: {
    width: 301,
    height: 132,
  },
};
